import {Layout, Button, Input, message, Table, ConfigProvider, Row,Col, Popconfirm, Statistic,Pagination, Popover,} from 'antd'
import { Content } from 'antd/lib/layout/layout'
import zhCN from 'antd/lib/locale/zh_CN'
import OAMSider from '../oam-sider'
import React, { useEffect, useRef, useState } from 'react'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'
import GlobalCss from '@/global.module.less'
import PublicTipModal from '@/pages/components/PublicTipModal/PublicTipModal'
import { BACKEND_API_URL } from '@/constants/constants'
import UserCard from '../user/oam-userinfo-card'

const { Search } = Input


export interface Props {}


export const OAMReportNodeList: React.FC<Props> = (props) => {
  const [nodeResult, setNodeResult] = useState([] as any[]) // 当前显示的结果页
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const [totalCount, setTotalCount] = useState(0) // 搜索返回的结果数
  const queryContent = useRef('') // 记录搜索串
  const querySource = useRef('2') // 来源 1-个人  2-OAM创建（系统）
  const order = useRef('') // 排序升序降序
  const order_by = useRef('') // 排序列
  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(10) // 记录当前每页展示数量
  const [onlineCount, setOnlineCount] = useState(0) //搜索返回的结果数


  const newName = useRef('') // 名称
  const [createModalVis, setCreateModalVis] = useState(false)
  const createOk = () => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      name: newName.current,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('report/api/oam_create_node/', data, (res) => {
      if (res.code == 0) {
        message.success('新建报告节点成功~')
        setCreateModalVis(false)
        queryNodeList()
      } else {
        message.error(res.message)
      }
    })
    newName.current = ''    
  }

  const createCancel = () => {
    setCreateModalVis(false)
    newName.current = ''
  }

  useEffect(() => {
    queryNodeList()
  }, [])

  /**
   * 查询节点列表
   */
  const queryNodeList = () => {
    sendHttpPostRequest(
      'report/api/oam_query_node_list/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        query: queryContent.current,
        page: page.current,
        pagesize: pageSize.current,
        order: order.current,
        order_by: order_by.current,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_report_node'
        } else if (response.is_ok == true) {
          // 成功
          setNodeResult(response.query_list)
          setResultSum(response.total_sum)
          setTotalCount(response.total_count)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_report_node'
        } else {
          message.error(response.message)
        }
      }
    )
  }


  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryNodeList()
  }



  // 删除回调
  const onDeleteBtnClickCallback = (response: any) => {
    message.destroy()
    if (response.code == 100) {
      // 没登录
      window.location.href = '/oam_login?next=oam_report_node'
    } else if (response.code == -501) {
      // 没权限
      window.location.href = '/oam_login?next=oam_report_node'
    } else if (response.is_ok == true) {
      message.success('删除报告节点~')
      queryNodeList()
    } else {
      message.error(response.message)
    }
  }

  // 点击 删除
  const onDeleteBtnClick = (nodeId: string) => {
    sendHttpPostRequest(
      'report/api/oam_delete_node/',
      {
        sessionid: Cookies.get('sessionid'),
        node_id: nodeId,
      },
      onDeleteBtnClickCallback
    )
  }



  // 渲染操作渲染操作
  const renderActions = (text: any, record: any) => {
    return (
      <Row justify="center" align="middle" gutter={[8, 4]} wrap={false}>
        <Col style={{ width: 50 }}>
          <Button
            style={{ borderRadius: 20, fontSize: 14 }}
            size="small"
            id="editit"
            type="dashed"
            onClick={onEditBtnClick.bind(this, record.id)}
          >
            {' '}
            编辑
          </Button>
        </Col>
        <Col style={{ width: 50 }}>
          <Popconfirm
            placement="top"
            title={'确认删除报告节点"' + record.title + '"吗？'}
            onConfirm={onDeleteBtnClick.bind(this, record.id)}
            okText="确认"
            cancelText="取消"
          >
            <Button
              style={{ borderRadius: 20, fontSize: 14 }}
              size="small"
              id="deleteexe"
              type="dashed"
              danger
            >
              {' '}
              删除
            </Button>
          </Popconfirm>
        </Col>
      </Row>
    )
  }

  //点击了编辑按钮
  const onEditBtnClick = (id: any, event: any) => {
    window.open('/oam_report_node_edit?node_id=' + id)
  }

  //点击了搜索按钮
  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    queryNodeList()
  }



  // 表格发生变化
  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      order.current = sorter.order
      order_by.current = sorter.field
    }

    page.current = 1
    queryNodeList()
  }

  const columns: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      width: 100,
    },
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      align: 'left',
      width: 130,
    },
    {
      title: '创建者',
      dataIndex: 'creator_name',
      key: 'creator_name',
      width: 150,
      align: 'left',
      render: (text, record) => {
        return (
          <Row align="middle" wrap={false}>
            <Col flex="40px">
              <Popover
                arrowPointAtCenter={true}
                trigger="hover"
                placement="left"
                content={<UserCard user_id={record?.creator_id} />}
                title={null}
              >
                <img
                  onMouseOver={() => {}}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 15,
                    cursor: 'pointer',
                  }}
                  src={
                    record?.creator_avatar?.startsWith('http')
                      ? record?.creator_avatar
                      : BACKEND_API_URL + record?.creator_avatar
                  }
                />
              </Popover>{' '}
            </Col>
            <Col flex="auto">
              <span>{text}</span>
            </Col>
          </Row>
        )
      },
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'center',
      width: 120,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
      defaultSortOrder: 'descend',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 220,
      ellipsis: false,
      align: 'center',
      fixed: 'right',
      render: renderActions,
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={['10']} openKeys={['sub-report']} />
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30, paddingBottom: 30 }}>
            <Row align="middle" gutter={16}>
              <Col flex="120px">
                <Statistic title="总报告节点" value={totalCount} />
              </Col>

              <Col flex="80px">
                <Statistic title="已上架" value={onlineCount} />
              </Col>
              <Col flex="250px">
                <Search
                  placeholder="搜索报告节点"
                  style={{ width: 350 }}
                  enterButton={true}
                  onSearch={onSearchBtn}
                />
              </Col>
              <Col flex="auto" style={{ textAlign: 'right' }}>
                <Button
                  type="primary"
                  style={{ float: 'right', marginRight: 20, borderRadius: 20 }}
                  onClick={()=>{setCreateModalVis(true)}}
                >
                  +报告节点
                </Button>
              </Col>
            </Row>
            <div style={{height:500}} className={GlobalCss.tableWrapper}>
              <ConfigProvider locale={zhCN}>
                <Table
                  dataSource={nodeResult}
                  columns={columns}
                  rowKey={(record) => record.id}
                  pagination={false}
                  scroll={{ x: 800 }}
                  //bordered={true}
                  onChange={onTableChange}
                />
              </ConfigProvider>
            </div>

            <ConfigProvider locale={zhCN}>
              <div
                style={{
                  marginBottom: 30,
                  paddingTop: 30,
                  textAlign: 'center',
                }}
                className={'css.pagination'}
              >
                <Pagination
                  defaultCurrent={1}
                  total={resultSum}
                  defaultPageSize={10}
                  hideOnSinglePage={true}
                  current={page.current}
                  onChange={onPageChange}
                  showQuickJumper={true}
                  showTotal={(total) => `共 ${total} 任务`}
                  pageSizeOptions={['10', '20', '50', '100']}
                />
              </div>
            </ConfigProvider>
          </div>
        </Content>
        <PublicTipModal
          modalContent={<div>
            <Row align={'middle'} justify={'start'} className={GlobalCss.formRow}>
            <Col className={GlobalCss.requiredLabel}>名称</Col>
            <Col>
              <Input
                style={{
                  width: '300px',
                }}
                placeholder="请输入节点名称"
                maxLength={50}
                onChange={(e) => {
                 newName.current = e.target.value
                }}
              />
            </Col>
          </Row>

          </div>
          }
          modalTitle={'创建报告节点'}
          handleOk={createOk}
          handleCancel={createCancel}
          open={createModalVis}
          setOpen={createModalVis}
        />
      </Layout>
    </Layout>
  )
}

export default OAMReportNodeList
